<div #divComponent [style.opacity]="opacity">
  <ng-content></ng-content>
</div>
